var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMasterCard(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6667 3.00195H1.33333C0.596954 3.00195 0 3.59891 0 4.33529V12.3353C0 13.0717 0.596954 13.6686 1.33333 13.6686H14.6667C15.403 13.6686 16 13.0717 16 12.3353V4.33529C16 3.59891 15.403 3.00195 14.6667 3.00195Z",
    fill: "#252525"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0013 11.6686C7.84225 11.6686 9.33463 10.1762 9.33463 8.33529C9.33463 6.49434 7.84225 5.00195 6.0013 5.00195C4.16035 5.00195 2.66797 6.49434 2.66797 8.33529C2.66797 10.1762 4.16035 11.6686 6.0013 11.6686Z",
    fill: "#EB001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0013 11.6686C11.8423 11.6686 13.3346 10.1762 13.3346 8.33529C13.3346 6.49434 11.8423 5.00195 10.0013 5.00195C8.16035 5.00195 6.66797 6.49434 6.66797 8.33529C6.66797 10.1762 8.16035 11.6686 10.0013 11.6686Z",
    fill: "#F79E1B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0013 5.66797C8.81093 6.27611 9.33464 7.24433 9.33464 8.33488C9.33464 9.42542 8.81093 10.3937 8.0013 11.0018C7.19167 10.3937 6.66797 9.42542 6.66797 8.33488C6.66797 7.24433 7.19167 6.27611 8.0013 5.66797Z",
    fill: "#FF5F00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCard);
export default __webpack_public_path__ + "static/media/master_card.edf29108b963997dc372b4473ca03e40.svg";
export { ForwardRef as ReactComponent };